'use client'

import { useState } from 'react'
import Image from 'next/image'
import { Link } from '@/components/site/link'
import { useTranslations } from 'next-intl'
import { Button, buttonVariants } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { SiteSection } from '@/components/site/site-section'
import allTestimonials from '@/content/testimonials.json'
import type { Locale } from '@/types/site'

// Carousel order from the v2 brief.
const ORDER = ['CACHE', 'Axioma', 'ITESM', 'G2X']
const testimonials = ORDER.map(
  (company) => allTestimonials.find((item) => item.company === company)!,
)

export function HomeTestimonials({ locale }: { locale: Locale }) {
  const t = useTranslations('home.testimonials')
  const tTestimonials = useTranslations('testimonials')
  const [active, setActive] = useState(0)
  const testimonial = testimonials[active]
  return (
    <SiteSection className="home-testimonials" title={t('title')}>
      <Card className="home-testimonial-card">
        <Image
          src={testimonial.image}
          alt={testimonial.imageAlt[locale]}
          width={650}
          height={450}
          sizes="(max-width: 809px) 100vw, 40vw"
        />
        <div className="home-testimonial-content">
          {testimonials.map((item, index) => (
            <div
              key={item.company}
              className="home-testimonial-pane"
              data-active={index === active ? '' : undefined}
              inert={index !== active}
            >
              <blockquote>{item.quote[locale]}</blockquote>
              <div className="home-testimonial-attribution">
                <div>
                  <p className="home-testimonial-person">{item.person}</p>
                  <p className="home-testimonial-role">{item.role[locale]}</p>
                </div>
                <Link
                  className={buttonVariants({ variant: 'outline', size: 'sm' })}
                  href={item.href[locale]}
                >
                  {tTestimonials('readCaseStudy')} →
                </Link>
              </div>
            </div>
          ))}
          <p className="sr-only" role="status">
            {testimonial.quote[locale]}
          </p>
        </div>
      </Card>
      <div className="home-testimonial-logos" aria-label={tTestimonials('selectTestimonial')}>
        {testimonials.map((item, index) => (
          <Button
            key={item.company}
            variant="ghost"
            aria-pressed={index === active}
            onClick={() => setActive(index)}
          >
            {/* The logo's alt text is the button's name: the client, for
                people and for machines reading the page. */}
            <Image src={item.logo} alt={item.name} width={180} height={64} sizes="150px" />
          </Button>
        ))}
      </div>
    </SiteSection>
  )
}
